import React, { useEffect, useRef } from "react";

import { useLocation } from "react-router-dom";
import { useWindowSize } from "react-use";

import { styled } from "@mui/material/styles";

import useQueryBoard from "../../lib/hooks/useQueryBoard";

import Clock from "../Clock";
import { useHeaderHeightContext } from "../../context/HeaderHeight";
import { useIsFrontAssistDomain } from "../../lib/hooks/useDomain";

const digitalReceptionBackground = new URL(
  "../../assets/images/DigitalReceptionBackground.png",
  import.meta.url,
);

const frontAssistBackground = new URL(
  "../../assets/images/FrontAssistBackground.png",
  import.meta.url,
);

const MUIHeroImage = styled("header")({
  height: "54.5rem",

  "@media screen and (orientation: landscape)": {
    height: "38rem",
  },

  "& div": {
    height: "100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",

    "@media screen and (orientation: landscape)": {
      backgroundSize: "100% auto",
      backgroundPosition: "50% 77%",
    },
  },
});

const Header = React.memo(() => {
  const { data, dataUpdatedAt } = useQueryBoard();

  const { width, height } = useWindowSize();

  const imageURL = data?.digitalReception?.theme?.images?.hero?.absolutePath;

  const { setHeight } = useHeaderHeightContext();
  const location = useLocation();

  const isFrontAssist = useIsFrontAssistDomain();

  const defaultBackground = isFrontAssist
    ? frontAssistBackground
    : digitalReceptionBackground;

  const headerRef = useRef<HTMLDivElement | null>(null);

  const updateHeaderHeight = () => {
    requestAnimationFrame(() => {
      if (headerRef.current) {
        setHeight(headerRef.current.getBoundingClientRect().height);
      }
    });
  };

  useEffect(() => {
    setTimeout(updateHeaderHeight, 0);
  }, [dataUpdatedAt, location.pathname]);

  useEffect(() => {
    window.addEventListener("resize", updateHeaderHeight);
    return () => {
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, []);

  if (
    (location.pathname === "/access/checkin/manual" ||
      location.pathname === "/access/checkin/manual/" ||
      location.pathname.startsWith("/access/checkin/missing-fields/")) &&
    width > height
  ) {
    return null;
  }

  return (
    <>
      <Clock />
      <MUIHeroImage key={dataUpdatedAt}>
        <div
          ref={headerRef}
          className="hero__image"
          style={{
            backgroundImage: `url("${imageURL ?? defaultBackground}")`,
          }}
        />
      </MUIHeroImage>
    </>
  );
});

export default Header;
